export default {
	token: state => state.user.token || '',
	username: state => state.user.username || '',
	userId: state => state.user.userId || '',
	userIsRoot: state => state.user.isRoot || '',
	routePath: state => state.routePath || ''
}
